import React from 'react';
import { formatMoney, formatNumberWithCommas } from '@app/utils/utils';

interface NumberFormatRenderProps {
  value: number;
  /** Mặc định là ô tiền tệ (kèm "đ"); truyền money={false} cho số đếm/điểm. */
  money?: boolean;
}

const NumberFormatRender = ({ value, money = true }: NumberFormatRenderProps) => {
  const negative = value < 0 ? 'text-danger' : 'text-primary';

  return (
    <span className={`flex-end ${negative}`}>
      {money ? formatMoney(Number(value)) : formatNumberWithCommas(Number(value))}
    </span>
  );
};

export default NumberFormatRender;
